/**
 * @format
 */

export const FeeEnumMixin = {
    data() {
        return {
            feeEnum: {
                mdfProcessingFee: '3.5%',
                mdfGlasshiveFee: '2.5%',
            },
        };
    },
};
